import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// images
import revitalizingNeighborhoodsImageDesktopWebp from './images/neighborhoods-desktop.webp';
import revitalizingNeighborhoodsImageMobileWebp from './images/neighborhoods-mobile.webp';
// base urls
import { nmFoundationBaseUrl } from '../../../../../utils/unsecuredLinks';

export default () => (
  <InformationalModule
    // configs
    sectionId='sustainability-impact-communities-revitalizing-neighborhoods'
    themeType='lightTheme'
    backgroundVariant='lightB'
    moduleName='financial-planning-module'
    moduleVariation='A'
    reverseContent
    // content
    subHeadingText='Revitalizing underserved neighborhoods'
    // column content
    columnContentA={(
      <>
        <Typography nextElement='button'>
          We believe that revitalizing underserved neighborhoods requires a long&#45;term, resident&#45;centered approach. We promote affordable homeownership, support homeowner retention through counseling and critical repairs, and improve food access and equity.
        </Typography>
        <Link
          id='sustainability-impact-communities-revitalizing-neighborhoods-link'
          variant='buttonLinkSecondary'
          linkUrl={`${nmFoundationBaseUrl}/neighborhood-focus/`}
          ariaLabel='Find out more about how we are revitalizing neighborhoods.'
          isInternalPdf>
          Find out more
        </Link>
      </>
    )}
    // image props
    imageAltText='Community members distributing supplies to children outdoors'
    imageSrcDefault={revitalizingNeighborhoodsImageDesktopWebp}
    imageSrcMobile={revitalizingNeighborhoodsImageMobileWebp}
  />
);
